<app-add-form
  [title]="title"
  [formFields]="formFields"
  [loading]="loading"
  [headerActions]="headerActions"
  (formAction)="onFormAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
></app-add-form>
